<template>
  <div
    ref="elRef"
    class="content-visibility"
    :class="{ parallax }"
    :data-many-scroller="sectionEntry"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useResizeObserver } from '@vueuse/core';
import { useManyScrollerOptions } from '@/composables/useManyScrollerOptions';
const { sectionEntry } = useManyScrollerOptions();

defineProps<{
  parallax: boolean;
}>();

const elRef = ref<HTMLElement | null>(null);
const containSize = ref<string | null>(null);
useResizeObserver(elRef, (entries) => {
  const entry = entries[0];
  const { width, height } = entry.contentRect;
  containSize.value = Math.round(width) + 'px ' + Math.round(height) + 'px';
});
</script>

<style lang="scss" scoped>
.content-visibility {
  // content-visibility: auto;
  contain-intrinsic-width: v-bind('containSize');

  .in-view & {
    content-visibility: visible;
  }

  .h-in-view:first-child & {
    content-visibility: visible;
  }
}
</style>
